var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallEnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5931_1035)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6096 1.33343L1.33343 15.6096L0.390625 14.6668L3.33422 11.7232C1.67467 9.84317 0.666767 7.37214 0.666767 4.66677V0.666767H5.2133L6.05713 4.88588L4.27603 6.66698C4.55895 7.66733 5.04915 8.58133 5.69791 9.35949L14.6668 0.390625L15.6096 1.33343ZM4.75183 10.3056C3.85667 9.26162 3.20504 8.00142 2.88636 6.61324L2.8038 6.25359L4.60974 4.44765L4.12023 2.0001H2.0001V4.66677C2.0001 7.0044 2.85877 9.14044 4.27911 10.7783L4.75183 10.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1143 9.94308L15.3334 10.7869V15.3334H11.3334C9.41154 15.3334 7.60649 14.8246 6.0478 13.9337L5.469 13.6029L6.1306 12.4453L6.7094 12.7761C8.07194 13.5548 9.64968 14.0001 11.3334 14.0001H14.0001V11.88L11.5526 11.3905L9.74661 13.1964L9.38697 13.1138C8.75137 12.9679 8.14244 12.7522 7.56879 12.4751L6.96847 12.1852L7.54832 10.9846L8.14864 11.2745C8.52663 11.457 8.92261 11.6081 9.33322 11.7242L11.1143 9.94308Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5931_1035"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEnd);
export default __webpack_public_path__ + "static/media/call-end.4150a9ea4afc9fef17a27c1d511eb6b4.svg";
export { ForwardRef as ReactComponent };